import React, { useState, useEffect,useRef } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios'
import { useNavigate } from "react-router-dom";
import { api_url } from '../config/config';

const EditProduct = () => {
  // State for storing form data
  const navigate = useNavigate();
  const [categoryDropdownOpen, setCategoryDropdownOpen] = useState(false);
    const [concernDropdownOpen, setConcernDropdownOpen] = useState(false);
    const [consumeDropdownOpen, setConsumeDropdownOpen] = useState(false);
const [selectedConsumeType, setSelectedConsumeType] = useState("");
const [selectedPackType, setSelectedPackType] = useState("");
    // const [selectedManualAlternatives, setSelectedManualAlternatives] = useState([]);
    const [selectedManualAlternatives, setSelectedManualAlternatives] = useState(new Set());
    const [manufacturerDropdownOpen, setManufacturerDropdownOpen] = useState(false);
    const [searchManufacturer, setSearchManufacturer] = useState("");
    const [selectedManufacturer, setSelectedManufacturer] = useState(""); // Store single selected manufacturer
    

  const [product, setProduct] = useState({});
  const [discountpercentage,setDiscountpercentage] = useState('');
  const  [concernids,setConernids] = useState([]);
  const [cateids,setCateIds] = useState([])
   const [viewAllAlters,setViewAllAlter] = useState([]);
     const [alterDropdownOpen,setAlterDropdownOpen] = useState(false);
       const [searchQuery, setSearchQuery] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
    const alterdropdownRef = useRef(null)
    const [alternativeProducts, setAlternativeProducts] = useState([]);

   const [primaryimage,setPrimaryimage] = useState()
   const [additionalImages, setAdditionalImages] = useState([]);
   const [packSize, setPackSize] = useState('');
    const [productSize, setProductSize] = useState('');
     const [Price,setPrice] = useState(null)
   const [previewPrimaryImages, setPreviewPrimaryImages] = useState([]);
   const [previewAdditionalImages, setPreviewAdditionalImages] = useState([]);
   const [viewAllCate, setViewAllCate] = useState([]);
   const [concern, setConcern] = useState([]);
   const [alternative,setAlternative] = useState([]);
   const [uploadedImages, setUploadedImages] = useState([]); // Actual file objects
   const [selectedImage, setSelectedImage] = useState(null);
    const [consumeType, setConsumeType] = useState('');
      const [expiryDate, setExpiryDate] = useState('');
  const [productName, setProductName] = useState('');
   const [shelfRackNo, setShelfRackNo] = useState('');
     const [howToUse, setHowToUse] = useState('');
   const [packType, setPackType] = useState("");
     const [quantity, setQuantity] = useState(null);
  const [productCode, setProductCode] = useState('');
  const [productDescription, setProductDescription] = useState('');
    const [prescription, setPrescription] = useState('');
     const [primaryUse, setPrimaryUse] = useState('');
     const [storageInstruction, setStorageInstruction] = useState('');
      const [sideEffects, setSideEffects] = useState(''); 
      //  const [alternative, setAlternative] = useState([]);
         const [keyIngredients, setKeyIngredients] = useState('');
  const [returnPolicy, setReturnPolicy] = useState('');
  const [manufacturer, setManufacturer] = useState('');
    const [composition, setComposition] = useState("");
    const [safetyAdvice, setSafetyAdvice] = useState('');
    const [benefits, setBenefits] = useState('');
  const [productCategory, setProductCategory] = useState([]);
  const [productDiscount, setProductDiscount] = useState(''); 
  const { id } = useParams();
  const [visibility, setVisibility] = useState('basic')
    const [viewAllConcerns, setViewAllConcerns] = useState([]);

  const [newImages, setNewImages] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [viewAllManufacturers, setViewAllManufacturers] = useState([]);
const [variants, setVariants] = useState([
      { pack_size: "", quantity: null, price: null, product_size: "" },
    ]);
    const dropdownRef = useRef(null);


    const toggleCategoryDropdown = () => {
      setCategoryDropdownOpen((prev) => !prev);
    };
  
    const handleSearchChange = (e) => {
      setSearchQuery(e.target.value);
    };

   

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setCategoryDropdownOpen(false);
      }
    };
  
    useEffect(() => {
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);
  
    const filteredCategories = viewAllCate?.filter((category) =>
      category.category_name.toLowerCase().includes(searchTerm.toLowerCase())
    );


    const filteredAlternative = viewAllAlters?.filter((item)=>
      item.name.toLowerCase().includes(searchQuery)
      );







  // Fetch product data to edit (useEffect)
  const fetchProductData = async () => {
    const response = await fetch(`${api_url}/admin-product/${id}`, {
      method: 'GET',
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
      },
    });
    const  data  = await response.json();

    if (data.data) {
      setProduct(data.data);
      setPrice(parseFloat(data.data.price))
      setProductName(data.data.name);  // Ensure this line is running when the data.data is available.
      setPackSize(data.data.pack_size)
      setPackType(data.data.pack_type || ""); // ✅ Ensures packType is stored
setSelectedPackType(data.data.pack_type || "");
      setProductSize(data.data.product_size)
      setProductCode(data.data.product_code);
      setDiscountpercentage(data.data.discount_percent)
      setProductDescription(data.data.description);
      data.data.category_ids.map((category) => {

        
setProductCategory((prevCategory) => [...prevCategory, category.category_id]);
        
      });

  // ✅ Store category & concern IDs
  setCateIds(data.data.category_ids.map((cat) => cat.category_id));
  setConernids(data.data.concern_ids.map((concern) => concern.concern_id));

     


    // ✅ Store only previously selected alternatives
    const savedAlternatives = data.data.alternativeProducts.map(
      (alt) => alt.product_id
    );
    setAlternative(savedAlternatives);
    setViewAllAlter(data.data.alternativeProducts); // ✅ Yeh UI ke liye necessary hai


      setProductDiscount(data.data.discounted_price);
      setReturnPolicy(data.data.return_policy);
      setManufacturer(data.data.manufacturer_id || ""); // ✅ Ensures manufacturer ID is set
      setSelectedManufacturer(data.data.manufacturer_id || "");
      setShelfRackNo(data.data.shelf_rack_no);
      setComposition(data.data.composition);
      setBenefits(data.data.benefits);
      setPrimaryUse(data.data.primary_use);
      setKeyIngredients(data.data.key_ingredients);
      setSideEffects(data.data.side_effects);
      setHowToUse(data.data.how_to_use);
      setSafetyAdvice(data.data.safety_advise);
      setStorageInstruction(data.data.storage_instruction);
      data.data.concern_ids.map((concern) => {
        setConcern((prevConcern) => [...prevConcern, concern.concern_id]);
      });
      // setAlternative(data.data.alternative)
      setConsumeType(data.data.consume_type || ""); // ✅ Prevents undefined values
    setSelectedConsumeType(data.data.consume_type || "");
      setExpiryDate(data.data.expire_date)
      setPreviewPrimaryImages(
        data.data?.product_images?.image_url?.primary_image || "https://via.placeholder.com/50"
      );
      setPreviewAdditionalImages(
        data.data?.product_images?.image_url?.additional_images || ["https://via.placeholder.com/50"]
      );
      
      

      setQuantity(data.data.quantity)
      setVariants(data.data.variant);
    }

  };

  useEffect(() => {
    addAlternativeProducts();
    // fetchAlternativeproduct()
    fetchProductData();
  }, [id]);

  // Handle update form submission
  const updateBasic = async () => {
    // e.preventDefault();

    var formData = new FormData();
    formData.append("name", productName);

    formData.append("product_code", productCode);
    formData.append("description", productDescription);
    // formData.append("product_type", productDescription);
    formData.append("product_concern", concern || "");
    formData.append("discount_percent", discountpercentage);
    formData.append("composition", composition);
    formData.append("consume_type", selectedConsumeType || consumeType || ""); // ✅ Ensures correct value is sent
formData.append("pack_type", selectedPackType || packType || ""); // ✅ Uses selectedPackType if available
formData.append("manufacturer_id", selectedManufacturer || manufacturer || ""); // ✅ Ensures correct manufacturer is sent

    formData.append("expire_date",expiryDate);
    formData.append("benefits", benefits);
    formData.append("how_to_use", howToUse);
    formData.append("safety_advise", safetyAdvice);
  
    formData.append("primary_use", primaryUse);
    formData.append("storage_instruction", storageInstruction);
    formData.append("side_effects", sideEffects);
    formData.append("return_policy", returnPolicy);
    formData.append("key_ingredients", keyIngredients);
    formData.append("shelf_rack_no", shelfRackNo);
    formData.append("variant", JSON.stringify(variants)  )

    if(concern){
      formData.append("concern_ids", JSON.stringify([...concern]));
    }
    if(alternative){
      formData.append("alternatives", JSON.stringify([...alternative]));
    }
   
    if(productCategory){
      formData.append("category_ids", JSON.stringify([...productCategory]));

    }
    
    if(primaryimage){
      formData.append("primary", primaryimage);

    }
    console.log("primary images",primaryimage)
    // formData.append("additional", additionalimage); 
    for (let i = 0; i < additionalImages.length; i++) {    
         formData.append("additional", additionalImages[i]); 
    }


    try {
      const response = await fetch(`${api_url}/product/${id}`, {
        method: "PATCH",
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
        },
        body: formData,
      });

      if (response.ok) {
        const result = await response.json();
        console.log("Response from API:", result);
        alert("Product details successfully updated!");
      } else {
        const error = await response.json();
        console.error("API Error:", error);
        alert("Failed to update product details. Please try again.");
      }
    } catch (error) {
      console.error("Network Error:", error);
      alert("An error occurred while updating the product. Please try again.");
    }
    navigate("/ng-admin/product-list")
  };


  const updatesettings = async () => {
    // e.preventDefault();

    var formData = new FormData();
  
   
    try {
      const response = await fetch(`${api_url}/product/${id}`, {
        method: "PATCH",
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
        },
        body: formData,
      });

      if (response.ok) {
        const result = await response.json();

        alert("Product details successfully updated!");
      } else {
        const error = await response.json();
        console.error("API Error:", error);
        alert("Failed to update product details. Please try again.");
      }
    } catch (error) {
      console.error("Network Error:", error);
      alert("An error occurred while updating the product. Please try again.");
    }
  };

  const fetchCategory = async () => {
    try {
      const { data } = await axios.get(
        `${api_url}/categories?page=1&limit=100`,
        {
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
          },
        }
      );
      console.log('API Response category:', data);  // Log to check the structure

      // Extract category names from the 'results' array
      setViewAllCate(data.results);
      const categoryIds = data.results.map((category) => category.category_id); 
      // localStorage.setItem("category_ids", JSON.stringify(categoryIds));
    } catch (e) {
      console.error("Error fetching categories:", e);
    }
  };

  const fetchConcerns = async () => {
    try {
      const { data } = await axios.get(
        `${api_url}/concerns?page=1&limit=100`,
        {
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
          },
        }
      );


      // Extract only the name of each concern and set it to the state
      setViewAllConcerns(data.results);

      const concernIds = data.results.map((concern) => concern.concern_id); 
      // concernIds.map((id)=>{
      //  if( concern.includes(id)){
      //   set
      //  }
      // })
      
      // localStorage.setItem("concern_ids", JSON.stringify(concernIds));

    } catch (e) {
      console.error('Error fetching concerns:', e);
    }
  };


useEffect(() => {
    fetchConcerns(); // Call fetchConcerns when the component mounts
}, []);



const addAlternativeProducts = async () => {
  if (concernids.length === 0 && cateids.length === 0) { 
    console.log("No concerns or categories selected.");
    return;
  }

  try {
    const response = await axios.post(`${api_url}/alternative-products`, {
      concern_ids: concernids,
      category_ids: cateids
    });

    console.log('Alternative products added:', response.data);
      // ✅ Keep only previously selected alternatives as checked
      const updatedAlternatives = response.data.map((alt) => ({
        ...alt,
        isChecked: alternative.includes(alt.product_id), // Only mark previously selected ones
      }));
  
      setViewAllAlter(updatedAlternatives);
    // setAlternative(response.data.map(item => item.product_id));
  } catch (error) {
    console.error('Error adding alternative products:', error);
  }
};

// useEffect(() => {
//   fetchProductData(); 
// }, [id]);

useEffect(() => {
  if (concernids.length > 0 || cateids.length > 0) {  
    addAlternativeProducts(); // ✅ Concern ya Category select hone pe alternative update hoga
  }
}, [concernids, cateids]);



  const fetchManufacturers = async () => {
    try {
      // Make API call
      const { data } = await axios.get(
        `${api_url}/manufacturer?page=1&limit=10`,
        {
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
          },
        }
      );

      console.log('API Response manufacurer:', data); // Log the full API response for debugging

      // Extract 'name' from each manufacturer in the results array
      if (data && data.results) {
        const manufacturers = data.results.map((item) => item.name);
        console.log('Extracted Manufacturer Names:', manufacturers); // Log extracted names
        setViewAllManufacturers(data.results); // Set state with extracted names
      }
    } catch (error) {
      console.error('Error fetching manufacturers:', error);
    }
  };

  // Call fetchManufacturers when the component mounts
  useEffect(() => {
    fetchManufacturers();
  }, []);


  





  useEffect(() => {
    fetchCategory();
  }, [])




  // const handleVariantChange = (index, field, value) => {
  //   const updatedVariants = variants.map((variant, i) =>
  //     i === index ? { ...variant, [field]: value } : variant
  //   );
  //   setVariants(updatedVariants);
  // };


  const handleVariantChange = (index, field, value) => {
    const updatedVariants = variants.map((variant, i) =>
      i === index ? { ...variant, [field]: field === "quantity" ? parseInt(value) || 0 : value } : variant
    );
    setVariants(updatedVariants);
  };
  

  const fetchAlternativeproduct = async () => {
    try {
        const response = await axios.get(
            `${api_url}/api/alternative/${productCode}`,
            {
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
                },
            }
        );


        setAlternativeProducts(response.data.data); // ✅ Corrected this line
        addAlternativeProducts()
    } catch (error) {
        console.error('Error fetching alternative products:', error);
    }
};

// Call fetchAlternativeproduct when the component mounts
useEffect(() => {
    if (productCode) { // ✅ Prevent calling API with empty productCode
        fetchAlternativeproduct();
    }
}, [productCode]);


 
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files); // Get all selected files
    setNewImages(files); // Store the selected files
  };

   const handleHowToUseChange = (e) => {
    setHowToUse(e.target.value); // Update the state with the input value
  };
  const handleExpiryDateChange = (e) => {
    const selectedDate = e.target.value; // Get date from input (YYYY-MM-DD)
    setExpiryDate(selectedDate); // Save the date directly
  };
  
  const handleSideEffectsChange = (e) => {
    setSideEffects(e.target.value); // Update the state on change
  };

 

  
  
  const handleStorageInstructionChange = (e) => {
    setStorageInstruction(e.target.value); // Update the state on change
  };

  const handleSafetyAdviceChange = (e) => {
    setSafetyAdvice(e.target.value); // Update the state with the input value
  };

  const handleConsumeTypeChange = (e) => {
    setConsumeType(e.target.value); // Update the state with selected value
  };

  const handleBenefitsChange = (e) => {
    setBenefits(e.target.value); 
  };

  const handlePrimaryUseChange = (e) => {
    setPrimaryUse(e.target.value); 
  };

  const handleUpdateImg = async () => {
    if (newImages.length === 0) return alert("Please select at least one image!");

    var formData = new FormData();
    formData.append("product_id", id); 
    // formData.append("product_code", productCode);



    try {
      const response = await fetch(`${api_url}/product/${id}`, {
        method: "PATCH",
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
        },
        body: formData,
      });


      if (response.ok) {
        const result = await response.json();
  
        alert("Product details successfully updated!");
        setShowPopup(false);
        setNewImages([]);
        fetchProductData();
      } else {
        const error = await response.json();
        console.error("API Error:", error);
        alert("Failed to update product details. Please try again.");
      }
    } catch (error) {
      console.error("Network Error:", error);
      alert("An error occurred while updating the product. Please try again.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Convert Price to a number before appending it to formData
    const parsedPrice = parseFloat(Price);

    if (isNaN(parsedPrice)) {
      console.error("Invalid price format. Please enter a valid number.");
      return;
    }

    const formData = new FormData();
    formData.append("price", parsedPrice); 
    // Add other fields to formData if necessary

    try {
      const response = await fetch("/api/products/update", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      console.log(data);
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };



  
  const handlePrimaryImageChange = (file) => {
    const maxFileSize = 2 * 1024 * 1024; 
setPrimaryimage(file)
    if (file) {
      if (file.size > maxFileSize) {
        console.log(`File ${file.name} exceeds the size limit of 2MB.`);
        return;
      }

      const previewUrl = URL.createObjectURL(file); 
      setPreviewPrimaryImages(previewUrl); 
    }
  };
  const handleCheckboxChange = (e, categoryId) => {
    const isChecked = e.target.checked;
  
    if (isChecked) {
      setProductCategory((prevCategories) => [...prevCategories, categoryId]);
      setCateIds((prev) => [...prev, categoryId]);
    } else {
      setProductCategory((prevCategories) =>
        prevCategories.filter((id) => id !== categoryId)
      );
      setCateIds((prev) => prev.filter((id) => id !== categoryId));
  
      // ✅ Find alternatives linked to the unchecked category
      const alternativesToRemove = viewAllAlters
        .filter((alt) => alt.category_ids?.includes(categoryId))
        .map((alt) => alt.product_id);
  
      // ✅ Keep manually selected alternatives checked
      setAlternative((prevAlternatives) =>
        prevAlternatives.filter(
          (alt) => !alternativesToRemove.includes(alt) || selectedManualAlternatives.has(alt)
        )
      );
  
      updateAlternativeProducts();
    }
  };
  
  
  const handleConsumeTypeSelection = (type) => {
    setSelectedConsumeType(type);
    setConsumeType(type); // ✅ Ensures API receives the updated value
    setConsumeDropdownOpen(false);
  };
  
  const handlePackTypeSelection = (type) => {
    setSelectedPackType(type);
    setPackType(type); // ✅ Ensures API receives the updated value
  };
  
  const handleManufacturerSelection = (manufacturerId) => {
    setSelectedManufacturer(manufacturerId);
    setManufacturer(manufacturerId); // ✅ Ensures API receives the updated value
    setManufacturerDropdownOpen(false);
  };
  
  
  
  
  

const handleAdditionalImagesChanges = (files) => {
  const maxFileSize = 2 * 1024 * 1024; // 2MB size limit
  const selectedFiles = Array.from(files);
  const newPreviews = [];
  const newFiles = [];

  selectedFiles.forEach((file) => {
    if (file.size > maxFileSize) {
      console.warn(`File ${file.name} exceeds the size limit of 2MB.`);
      return;
    }
    newPreviews.push(URL.createObjectURL(file)); // Create preview URL
    newFiles.push(file); // Add file to the list
  });

  // Add new images to the existing list
  setPreviewAdditionalImages((prev) => [...prev, ...newPreviews]);
  setAdditionalImages(files)
  setUploadedImages((prev) => [...prev, ...newFiles]);
};


const updateAlternativeProducts = () => {
  if (concernids.length === 0 && cateids.length === 0) {
    console.log("No concerns or categories selected.");
    setViewAllAlter([]); // ✅ Clear alternatives when no category/concern is selected
    return;
  }

  // ✅ Keep only alternatives related to the currently selected categories/concerns
  const filteredAlternatives = viewAllAlters.filter(
    (alt) =>
      cateids.some((cat) => alt.category_ids?.includes(cat)) ||
      concernids.some((con) => alt.concern_ids?.includes(con))
  );

  setViewAllAlter(filteredAlternatives);

  // ✅ Keep manually selected alternatives checked
  setAlternative((prevAlternatives) =>
    prevAlternatives.filter((alt) =>
      filteredAlternatives.some((item) => item.product_id === alt)
    )
  );

  // ✅ Ensure checkboxes remain checked for manually selected alternatives
  setViewAllAlter((prevAlters) =>
    prevAlters.map((alt) => ({
      ...alt,
      isChecked: alternative.includes(alt.product_id),
    }))
  );
};






// Function to delete the selected image
const handleDeleteImage = async () => {
  if (!selectedImage) {
    alert("No image selected!");
    return;
  }

  try {
    const response = await fetch(`${api_url}/products/image`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
      },
      body: JSON.stringify({
        image_url: selectedImage,
        product_id: id,
      }),
    });

    if (response.ok) {
      console.log("Image deleted successfully");

      // Remove the image from previewAdditionalImages and uploadedImages
      setPreviewAdditionalImages((prev) =>
        prev.filter((url) => url !== selectedImage)
      );
      setUploadedImages((prev) =>
        prev.filter((_, idx) => previewAdditionalImages[idx] !== selectedImage)
      );

      setSelectedImage(null); // Clear the selected image
      URL.revokeObjectURL(selectedImage); // Free up memory
    } else {
      console.error("Failed to delete the image");
    }
  } catch (error) {
    console.error("An error occurred while deleting the image:", error);
  }
};

const toggleConcernDropdown = () => {
  setConcernDropdownOpen(!concernDropdownOpen);
  setCategoryDropdownOpen(false); // Close category dropdown when concern opens
};

const handleConcernCheckboxChange = (e, concernId) => {
  if (e.target.checked) {
    setConcern([...concern, concernId]);
    setConernids((prev) => [...prev, concernId]);
  } else {
    setConcern(concern.filter((id) => id !== concernId));
    setConernids((prev) => prev.filter((id) => id !== concernId));

    // ✅ Find alternatives linked to the unchecked concern
    const alternativesToRemove = viewAllAlters
      .filter((alt) => alt.concern_ids?.includes(concernId))
      .map((alt) => alt.product_id);

    // ✅ Keep manually selected alternatives checked
    setAlternative((prevAlternatives) =>
      prevAlternatives.filter(
        (alt) => !alternativesToRemove.includes(alt) || selectedManualAlternatives.has(alt)
      )
    );

    updateAlternativeProducts();
  }
};








const toggleAlterDropdown = () => {
  setAlterDropdownOpen(!alterDropdownOpen);
};




const handleCheckboxAlter = (e, alterId) => {
  if (e.target.checked) {
    setAlternative([...alternative, alterId]);

    // ✅ Add manually selected alternative to the set
    setSelectedManualAlternatives((prev) => new Set([...prev, alterId]));
  } else {
    setAlternative(alternative.filter((id) => id !== alterId));

    // ✅ Remove from manually selected alternatives when unchecked manually
    setSelectedManualAlternatives((prev) => {
      const newSet = new Set(prev);
      newSet.delete(alterId);
      return newSet;
    });
  }
};






  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-lg">
      <h1 className="text-3xl font-semibold mb-6">Edit Product <span className="text-blue-500 font-poppins font-bold">{product.name}</span></h1>
      <div className='flex gap-5  pb-10'>
        <button onClick={() => setVisibility('basic')} className='p-2 bg-[#3C1F1F] hover:bg-blue-400 rounded-lg text-white active:bg-green-400'>Basic</button>
        <button onClick={() => setVisibility('setttings')} className='p-2  bg-[#3C1F1F] hover:bg-blue-400 rounded-lg text-white active:bg-green-400'>Settings</button>
        <button onClick={() => setVisibility('variants')} className='p-2  bg-[#3C1F1F] hover:bg-blue-400 rounded-lg text-white active:bg-green-400'>Variants</button>
        <button onClick={() => setVisibility('Image')} className='p-2  bg-[#3C1F1F] hover:bg-blue-400 rounded-lg text-white active:bg-green-400'>Image</button>
       
      </div>
      {
        visibility === 'basic' && (
          <div>


            <div className='flex gap-4 py-2'>

              <div className="flex flex-col flex-1">
                <label className="text-sm font-medium text-gray-600 mb-2">Product Name</label>
                <input
  id='name'
  value={productName}
  onChange={(e) => setProductName(e.target.value)} // ensure this is updating the state
  className="p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
  placeholder="Enter product name"
/>

              </div>

              {/* Product Code */}
              <div className="flex flex-col">
                <label className="text-sm font-medium text-gray-600 mb-2">Product Code</label>
                <input
                  // type="text"
                    id="productCode"
                  value={productCode}
                  onChange={(e) => setProductCode(e.target.value)}
                  className="p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  placeholder="Enter product code"
                  // disabled={true}
                />
              </div>

                   {/* Discount Percentage Field */}
                   <div className="mb-4">
            <label
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Discount Percentage
            </label>
            <input
              id="discount_percent"
              type="number"
                 className="p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
              value={discountpercentage || ""}
              onChange={(e) => setDiscountpercentage(e.target.value)}
            />
          </div>



            </div>

            {/* Description */}
            <div className="flex flex-col py-2">
              <label className="text-sm font-medium text-gray-600 mb-2">Description</label>
              <textarea
                value={productDescription}
                id="productDescription"
                onChange={(e) => setProductDescription(e.target.value)}
                className="p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 h-[200px]"
                placeholder="Enter product description"
              />
            </div>


    

                {/* <!-- Expiry Date Input --> */}
                <div className="mb-4">
      <label htmlFor="expiryDate" className="block text-gray-700 font-medium mb-2">
        Expire Date:
      </label>
      <input 
        // type="date" 
        id="expire_date" 
        name="expiryDate" 
        value={expiryDate} 
        onChange={handleExpiryDateChange} 
        className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring focus:ring-blue-500 focus:outline-none"
      />
    </div>


     {/* <!-- benefits  Input --> */}
      <div className="mb-4">
        <label htmlFor="Benefits" className="block text-gray-700 font-medium mb-2">
          Benefits
        </label>
        <input
          type="text"
          id="Benefits"
          name="Benefits"
          value={benefits} // Bind state value to the input
          onChange={handleBenefitsChange} // Update state on change
          className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring focus:ring-blue-500 focus:outline-none"
        />
      </div>

    {/* <!-- Primary Use --> */}

    <div className="mb-4">
    <label htmlFor="primaryUse" className="block text-gray-700 font-medium mb-2">
      Primary Use
    </label>
    <input 
      type="text" 
      id="primary_use" 
      name="primaryUse" 
      value={primaryUse} // Bind the value of the input to the state
      onChange={handlePrimaryUseChange} // Update the state when the input changes
      className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring focus:ring-blue-500 focus:outline-none"
      placeholder="Enter primary use of medicine"
      required
    />
  </div>

         {/* composition */}

         <div className="mb-4">
      <label htmlFor="composition" className="block text-gray-700 font-medium mb-2">
        Composition
      </label>
      <textarea
        id="composition"
        name="composition"
        value={composition} // Bind the state variable
        onChange={(e) => setComposition(e.target.value)} // Update state on change
        rows="3"
        className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring focus:ring-blue-500 focus:outline-none"
        placeholder="Enter storage instructions"
      ></textarea>

    </div>
         
               {/* key ingredients */}
               <div className="mb-4">
    <label
      htmlFor="keyingredients"
      className="block text-gray-700 font-medium mb-2"
    >
      Key Ingredients
    </label>
    <input
      type="text"
      id="key_ingredients"
      name="keyingredients"
      className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring focus:ring-blue-500 focus:outline-none"
      placeholder="Enter key ingredients"
      value={keyIngredients} // Bind value to state
      onChange={(e) => setKeyIngredients(e.target.value)} // Update state on change
    />
  </div>
        
        {/* return policy */}

            <div className="flex flex-col py-2">
              <label className="text-sm font-medium text-gray-600 mb-2">Return Policy</label>
              <textarea
                type="text"
                value={returnPolicy}
                onChange={(e) => setReturnPolicy(e.target.value)}
                className="p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                placeholder="Enter manufacturer"
              />
            </div>

      {/* <!-- Side Effects --> */}
      <div className="mb-4">
    <label htmlFor="sideEffects" className="block text-gray-700 font-medium mb-2">
      Side Effects
    </label>
    <textarea
      id="side_effects"
      name="sideEffects"
      rows="3"
      value={sideEffects} // Bind the value of the textarea to the state
      onChange={handleSideEffectsChange} // Update the state when the textarea changes
      className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring focus:ring-blue-500 focus:outline-none"
      placeholder="Enter side effects"
    ></textarea>
  </div>

             {/* use of input */}
      <div className="mb-4">
        <label htmlFor="howToUse" className="block text-gray-700 font-medium mb-2">
          How to use
        </label>
        <input
          type="text"
          id="how_to_use"
          name="howToUse"
          value={howToUse} // Bind state value to the input
          onChange={handleHowToUseChange} // Update state on change
          className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring focus:ring-blue-500 focus:outline-none"
        />
      </div>

  

       

                {/* advice of input */}
      <div className="mb-4">
        <label htmlFor="safetyAdvice" className="block text-gray-700 font-medium mb-2">
          Safety Advice
        </label>
        <input
          type="text"
          id="safety_advise"
          name="safetyAdvice"
          value={safetyAdvice} // Bind state value to the input
          onChange={handleSafetyAdviceChange} // Update state on change
          className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring focus:ring-blue-500 focus:outline-none"
        />
      </div>
 

    

            {/* <!-- Storage Instructions --> */}
           <div className="mb-4">
    <label htmlFor="storageInstruction" className="block text-gray-700 font-medium mb-2">
      Storage Instruction
    </label>
    <textarea
      id="storage_instruction"
      name="storageInstruction"
      rows="3"
      value={storageInstruction} // Bind the value of the textarea to the state
      onChange={handleStorageInstructionChange} // Update the state when the textarea changes
      className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring focus:ring-blue-500 focus:outline-none"
      placeholder="Enter storage instructions"
    ></textarea>
  </div>
  
         
          </div>
        )
      }
      {
        visibility === 'setttings' && (
          <div>
            <div className="mb-6">
              <h2 className="text-lg font-semibold mb-4">Product Details</h2>
              <div className="mb-4 relative" ref={dropdownRef}>
      <label htmlFor="productCategory" className="block text-sm font-medium text-gray-700 mb-2">
        Product Category
      </label>

      <div
        className="w-full border border-gray-300 rounded-lg p-3 focus:ring-blue-500 focus:border-blue-500 cursor-pointer flex justify-between items-center"
        onClick={toggleCategoryDropdown}
      >
        <span>
          {Array.isArray(productCategory) && productCategory.length > 0
            ? Array.isArray(viewAllCate)
              ? viewAllCate
                  .filter((category) => productCategory.includes(category.category_id))
                  .map((cat) => cat.category_name)
                  .join(", ")
              : "Loading categories..."
            : "Select a category"}
        </span>
        <span className="text-gray-500">{categoryDropdownOpen ? "▲" : "▼"}</span>
      </div>

      {categoryDropdownOpen && (
        <div className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-lg shadow-lg max-h-52 overflow-y-auto">
          <div className="p-2">
            <input
              type="text"
              placeholder="Search categories..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          {filteredCategories && filteredCategories.length > 0 ? (
            filteredCategories.map((category) => (
              <div key={category.category_id} className="flex items-center px-3 py-2">
                <input
                  type="checkbox"
                  id={`category_${category.category_id}`}
                  name={`category_${category.category_id}`}
                  value={category.category_id}
                  checked={productCategory.includes(category.category_id)}
                  onChange={(e) => handleCheckboxChange(e, category.category_id)}
                  className="mr-2"
                />
                <label htmlFor={`category_${category.category_id}`} className="text-sm text-gray-700">
                  {category.category_name}
                </label>
              </div>
            ))
          ) : (
            <div className="p-3 text-sm text-gray-500">No categories found</div>
          )}
        </div>
      )}
    </div>



           


            </div>
        {/* Manufacturer */}
        <div className="mb-4 relative">
  <label htmlFor="manufacturer" className="block text-sm font-medium text-gray-700 mb-2">
    Manufacturer
  </label>

  {/* Custom Dropdown */}
  <div
  className="w-full border border-gray-300 rounded-lg p-3 justify-between items-center flex"
  onClick={() => setManufacturerDropdownOpen(!manufacturerDropdownOpen)}
>
  <span>
    {selectedManufacturer
      ? viewAllManufacturers.find((manu) => manu.manufacturer_id === selectedManufacturer)?.name
      : "Select a manufacturer"}
  </span>
    {/* Dropdown Arrow */}
    <span className="text-gray-500">{manufacturerDropdownOpen ? "▲" : "▼"}</span>
  </div>

  {manufacturerDropdownOpen && (
    <div
      className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-lg shadow-lg max-h-52 overflow-y-auto"
      style={{ maxHeight: "200px" }}
    >
      {/* Search Input */}
      <div className="p-2">
        <input
          type="text"
          placeholder="Search manufacturers..."
          value={searchManufacturer}
          onChange={(e) => setSearchManufacturer(e.target.value)}
          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      {/* Manufacturer List */}
      {Array.isArray(viewAllManufacturers) && viewAllManufacturers.length > 0 ? (
        viewAllManufacturers
          .filter((item) =>
            item.name.toLowerCase().includes(searchManufacturer.toLowerCase())
          )
          .map((item) => (
            <div
              key={item.manufacturer_id}
              className={`px-3 py-2 hover:bg-gray-100 cursor-pointer ${
                selectedManufacturer === item.manufacturer_id ? "bg-blue-100" : ""
              }`}
              onClick={() => handleManufacturerSelection(item.manufacturer_id)}
            >
              {item.name}
            </div>
          ))
      ) : (
        <div className="p-3 text-sm text-gray-500">No manufacturers available</div>
      )}
    </div>
  )}
</div>


    {/* concern  */}

    <div className="mb-4 relative">
  <label htmlFor="concern" className="block text-sm font-medium text-gray-700 mb-2">
    Concern
  </label>

  {/* Custom Dropdown */}
  <div
    className="w-full border border-gray-300 rounded-lg p-3 focus:ring-blue-500 focus:border-blue-500 cursor-pointer flex justify-between items-center"
    onClick={toggleConcernDropdown}
  >
    <span>
      {Array.isArray(concern) && concern.length > 0
        ? Array.isArray(viewAllConcerns)
          ? viewAllConcerns
              .filter((item) => concern.includes(item.concern_id)) // ✅ Fixed this condition
              .map((item) => item.name)
              .join(", ")
          : "Loading concerns..."
        : "Select a concern"
      }
    </span>
    {/* Dropdown Arrow */}
    <span className="text-gray-500">{concernDropdownOpen ? "▲" : "▼"}</span>
  </div>

  {concernDropdownOpen && (
    <div
      className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-lg shadow-lg max-h-52 overflow-y-auto"
      style={{ maxHeight: "200px" }}
    >
      {Array.isArray(viewAllConcerns) && viewAllConcerns.length > 0 ? (
        viewAllConcerns.map((item) => (
          <div key={item.concern_id} className="flex items-center px-3 py-2">
            <input
              type="checkbox"
              id={`concern_${item.concern_id}`}
              name={`concern_${item.concern_id}`}
              value={item.concern_id}
              checked={concern.includes(item.concern_id)} 
              onChange={(e) => handleConcernCheckboxChange(e, item.concern_id)}
              className="mr-2"
            />
            <label htmlFor={`concern_${item.concern_id}`} className="text-sm text-gray-700">
              {item.name}
            </label>
          </div>
        ))
      ) : (
        <div className="p-3 text-sm text-gray-500">No concerns available</div>
      )}
    </div>
  )}
</div>

{/* Alternative */}

<div className="mb-4 relative">
  <label className="block text-sm font-medium text-gray-700 mb-2">
    Alternative
  </label>
  <div className="relative" ref={alterdropdownRef}>
    <div
      className="w-full border border-gray-300 rounded-lg p-3 focus:ring-blue-500 focus:border-blue-500 cursor-pointer flex justify-between items-center"
      onClick={() => setAlterDropdownOpen(!alterDropdownOpen)}
    >
      <span>
        {alternative.length > 0
          ? viewAllAlters
              .filter((alt) => alternative.includes(alt.product_id))
              .map((alt) => alt.name)
              .join(", ")
          : "Select an alternative"}
      </span>
      <span className="text-gray-500">{alterDropdownOpen ? "▲" : "▼"}</span>
    </div>

    {alterDropdownOpen && (
      <div className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-lg shadow-lg max-h-52 overflow-y-auto">
        {viewAllAlters.length > 0 ? (
          viewAllAlters.map((alt) => (
            <div key={alt.product_id} className="flex items-center px-3 py-2">
              <input
                type="checkbox"
                id={`alternative_${alt.product_id}`}
                name={`alternative_${alt.product_id}`}
                value={alt.product_id}
                // checked={alternative.includes(alt.product_id) || alt.isChecked}
                checked={alternative.includes(alt.product_id) || selectedManualAlternatives.has(alt.product_id)}


                onChange={(e) => handleCheckboxAlter(e, alt.product_id)}
                className="mr-2"
              />
              <label htmlFor={`alternative_${alt.product_id}`} className="text-sm text-gray-700">
                {alt.name}
              </label>
            </div>
          ))
        ) : (
          <div className="text-sm text-gray-500 px-3 py-2">No Alternative found.</div>
        )}
      </div>
    )}
  </div>
</div>

         
                     {/* consume type */}

                     <div className="mb-4 relative">
  <label htmlFor="consume_type" className="block text-sm font-medium text-gray-700 mb-2">
    Consume Type:
  </label>

  {/* Custom Dropdown */}
  <div
  className="w-full border border-gray-300 rounded-lg p-3"
  onClick={() => setConsumeDropdownOpen(!consumeDropdownOpen)}
>
  <span>{selectedConsumeType || consumeType || "Select Consume Type"}</span> {/* ✅ Fix: Pre-select */}
</div>


  {consumeDropdownOpen && (
    <div
      className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-lg shadow-lg max-h-52 overflow-y-auto"
      style={{ maxHeight: "200px" }}
    >
      {/* Consume Type List */}
      {["Oral", "Non Consumable", "Topical", "Injectable", "Inhalable"].map((type) => (
        <div
          key={type}
          className={`px-3 py-2 hover:bg-gray-100 cursor-pointer ${
            selectedConsumeType === type ? "bg-blue-100" : ""
          }`}
          onClick={() => handleConsumeTypeSelection(type)}
        >
          {type}
        </div>
      ))}
    </div>
  )}
</div>

          {/* pack Type  */}

<div className="mb-4">
  <label className="block text-sm font-medium text-gray-700 mb-1">
    Pack Type:
  </label>
  <select
  value={selectedPackType || packType} // ✅ Uses selectedPackType if available, otherwise fallback to packType
  onChange={(e) => {
    setPackType(e.target.value);
    setSelectedPackType(e.target.value); // ✅ Ensures dropdown UI updates
  }}
>
  <option value="" className='w-full'>Select Pack Type</option>
  <option value="Strip">Strip</option>
  <option value="Bottle">Bottle</option>
  <option value="Packet">Packet</option>
  <option value="Jar">Jar</option>
</select>
</div>

          </div>
        )
      }
    {visibility === "variants" && (

  <>
    {/* Log variants data to debug */}

    {variants && variants.length > 0 ? (

      variants.map((variant, index) => (
        <div key={index} className="mb-6">
    

          {/* Variant Fields */}
          <div className="space-y-4">
            {/* Flex Container for Pack Size, Quantity, and Price */}
            <div className="flex space-x-4">
              {/* Pack Size Field */}
              <div className="flex-1">
                <label className="block text-sm font-medium">Pack Size</label>
                <input
                  id={`pack_size_${index}`}
                  type="text"
                  value={variant.pack_size || ""}
                  onChange={(e) =>
                    handleVariantChange(index, "pack_size", e.target.value)
                  }
                  required
                  className="mt-1 block w-full p-2 border rounded-md"
                />
              </div>

              {/* Quantity Field */}
              <div className="flex-1">
                <label className="block text-sm font-medium">Quantity</label>
                <input
                  id={`quantity_${index}`}
                  type="number"
                  placeholder="Quantity"
                  value={variant.quantity || ""}
                  onChange={(e) =>
                    handleVariantChange(index, "quantity", e.target.value)
                  }
                  required
                  className="mt-1 block w-full p-2 border rounded-md"
                />
              </div>

              {/* Price Field */}
              <div className="flex-1">
                <label className="block text-sm font-medium">Price</label>
                <input
                  id={`price_${index}`}
                  type="number"
                  placeholder="Price"
                  value={variant.price || ""}
                  onChange={(e) =>
                    handleVariantChange(index, "price", parseFloat(e.target.value))
                  }
                  required
                  className="mt-1 block w-full p-2 border rounded-md"
                />
              </div>
            </div>

            {/* Product Size Field */}
            <div className='flex space-x-0'>
              <div className='flex-1'>
              <label className="block text-sm font-medium">Product Size</label>
              <input
                id={`product_size_${index}`}
                type="text"
                value={variant.product_size || ""}
                onChange={(e) =>
                  handleVariantChange(index, "product_size", e.target.value)
                }
                required
                className="mt-1 block p-2 border rounded-md w-1/4"
              />
              </div>

           
            </div>
         
          </div>
        </div>
      ))
    ) : (
      <p>No variants available</p>
    )}
  </>
)}

      {
        visibility === 'Image' && (

     
<div className='flex gap-5'>
      {/* Primary Image */}
      <div className="mb-4">
        <h4 className="text-md font-medium mb-1">Primary Image</h4>
        <input
          type="file"
          id="primary-image"
          className="hidden"
          onChange={(e) => handlePrimaryImageChange(e.target.files[0])}
        />
        <label
          htmlFor="primary-image"
          className="cursor-pointer w-20 h-20 flex items-center justify-center border border-dashed border-gray-300 rounded-md text-gray-400 hover:bg-gray-50"
        >
          Upload
        </label>
        {previewPrimaryImages && (
          <div className="mt-2">
            <img
              src={previewPrimaryImages}
              alt="Primary Image"
              className="w-20 h-20 object-cover rounded-md border"
            />
          </div>
        )}
      </div>

      {/* Additional Images */}
      <div>
      <h4 className="text-md font-medium mb-1">Additional Images</h4>

      {/* File input for uploading images */}
      <input
        type="file"
        id="additional-images"
        className="hidden"
        multiple
        onChange={(e) => handleAdditionalImagesChanges(e.target.files)}
      />
      <label
        htmlFor="additional-images"
        className="cursor-pointer w-20 h-20 flex items-center justify-center border border-dashed border-gray-300 rounded-md text-gray-400 hover:bg-gray-50"
      >
        Upload
      </label>

      {/* Display additional images */}
      {previewAdditionalImages.length > 0 && (
        <div className="mt-2 flex gap-4 flex-wrap">
          {previewAdditionalImages.map((url, index) => (
            <div key={index} className="relative">
              <img
                src={url}
                alt={`Additional Image ${index + 1}`}
                className={`w-20 h-20 object-cover rounded-md border cursor-pointer ${
                  selectedImage === url ? "border-blue-500" : ""
                }`}
                onClick={() => setSelectedImage(url)} // Set the selected image
              />
            </div>
          ))}
        </div>
      )}

      {/* Delete button */}
      {selectedImage && previewAdditionalImages.length > 0 && (
        <button
          onClick={handleDeleteImage}
          className="mt-4 bg-red-500 text-white text-sm px-4 py-2 rounded-md"
        >
          Delete Selected Image
        </button>
      )}
    </div>
    </div>
        )
      }
    {/* Save Changes Button */}
    <div className="flex justify-end">
              <button
                type="submit"
                className="px-6 py-3  bg-[#3C1F1F] text-white font-semibold rounded-lg shadow-md hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                onClick={updateBasic}
              >
                Save Changes
              </button>
            </div>

    </div>
  );
};

export default EditProduct;

